<template>
  <div class="block-layout-header-simple">
    <div class="block-layout-header-simple__column">
      <UtilRouteLink       
        link="/"
        target="_self"
      >
        <IonIcon
          icon-name="swissmilk-logo"
          icon-size="var(--logo-width)"
        />
      </UtilRouteLink>

      <UtilRouteLink
        v-if="promoLink"
        :link="promoLink"
        target="_self"
        class="block-layout-header-simple__promo-link"
      >
        <AtomButton
          :text="promoLinkText"
          size="small"
          background-color="var(--c-primary-200)"
          border-color="var(--c-primary-200)"
          text-color="var(--c-primary-500)"
        />
      </UtilRouteLink>
    </div>

    <div class="block-layout-header-simple__column">
      <BlockNavigationLanguageDropdown
        class="block-layout-header-simple__language"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
    promoLink: {
        type: String,
        default: '',
    },

    promoLinkText: {
        type: String,
        default: '',
    },
});
</script>

<style lang="scss" scoped>
.block-layout-header-simple {
    @include fluid('--padding-top', 30px, 34px, 53px);
    @include fluid('padding-bottom', 30px, 34px, 53px);
    @include fluid('column-gap', 10px, 20px, 30px);
    @include z-index('header');
    @include fluid-simple('--logo-width', 19px, 29px);

    position: absolute;
    top: 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-top: var(--padding-top);
    padding-right: var(--page-padding);
    padding-left: var(--page-padding);
}

.block-layout-header-simple__logo {
    width: 100px;
}

.block-layout-header-simple__column {
    @include fluid('column-gap', 10px, 20px, 30px);

    display: flex;
    align-items: center;
}

.block-layout-header-simple__promo-link {
    display: none;

    @include tablet {
        display: block;
    }
}
</style>
